import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you no longer need to use a package in your code, we recommend uninstalling it and removing it from your project's dependencies.`}</p>
    <h2>{`Uninstalling local packages`}</h2>
    <h3>{`Removing a local package from your node_modules directory`}</h3>
    <p>{`To remove a package from your node_modules directory, on the command line, use the `}<a parentName="p" {...{
        "href": "/cli/uninstall"
      }}><inlineCode parentName="a">{`uninstall`}</inlineCode>{` command`}</a>{`. Include the scope if the package is scoped.`}</p>
    <p>{`This uninstalls a package, completely removing everything npm installed on its behalf.`}</p>
    <p>{`It also removes the package from the dependencies, devDependencies, optionalDependencies, and peerDependencies objects in your package.json.`}</p>
    <p>{`Further, if you have an npm-shrinkwrap.json or package-lock.json, npm will update those files as well.`}</p>
    <h4>{`Unscoped package`}</h4>
    <pre><code parentName="pre" {...{}}>{`npm uninstall <package_name>

`}</code></pre>
    <h4>{`Scoped package`}</h4>
    <pre><code parentName="pre" {...{}}>{`npm uninstall <@scope/package_name>
`}</code></pre>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{}}>{`npm uninstall lodash
`}</code></pre>
    <h3>{`Removing a local package without removing it from package.json`}</h3>
    <p>{`Using the `}<inlineCode parentName="p">{`--no-save`}</inlineCode>{` will tell npm not to remove the package from your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{`, or `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files.`}</p>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{}}>{`npm uninstall --no-save lodash
`}</code></pre>
    <Note mdxType="Note">
      <p><inlineCode parentName="p">{`--save`}</inlineCode>{` or `}<inlineCode parentName="p">{`-S`}</inlineCode>{` will tell npm to remove the package from your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{`, and `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files. `}<strong parentName="p">{`This is the default`}</strong>{`, but you may need to use this if you have for instance `}<inlineCode parentName="p">{`save=false`}</inlineCode>{` in your `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file.`}</p>
    </Note>
    <h3>{`Confirming local package uninstallation`}</h3>
    <p>{`To confirm that `}<inlineCode parentName="p">{`npm uninstall`}</inlineCode>{` worked correctly, check that the `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` directory no longer contains a directory for the uninstalled package(s).`}</p>
    <ul>
      <li parentName="ul">{`Unix system (such as OSX): `}<inlineCode parentName="li">{`ls node_modules`}</inlineCode></li>
      <li parentName="ul">{`Windows systems: `}<inlineCode parentName="li">{`dir node_modules`}</inlineCode></li>
    </ul>
    <h2>{`Uninstalling global packages`}</h2>
    <p>{`To uninstall an unscoped global package, on the command line, use the `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{` command with the `}<inlineCode parentName="p">{`-g`}</inlineCode>{` flag. Include the scope if the package is scoped.`}</p>
    <h3>{`Unscoped package`}</h3>
    <pre><code parentName="pre" {...{}}>{`npm uninstall -g <package_name>
`}</code></pre>
    <h3>{`Scoped package`}</h3>
    <pre><code parentName="pre" {...{}}>{`npm uninstall -g <@scope/package_name>
`}</code></pre>
    <h3>{`Example`}</h3>
    <p>{`For example, to uninstall a package called `}<inlineCode parentName="p">{`jshint`}</inlineCode>{`, run:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm uninstall -g jshint
`}</code></pre>
    <h2>{`Resources`}</h2>
    <h3>{`Uninstalling local packages`}</h3>
    <iframe src="https://www.youtube.com/embed/Z-BpYj6cSoQ" frameBorder="0" allowFullScreen></iframe>
    <h3>{`Uninstalling global packages`}</h3>
    <iframe src="https://www.youtube.com/embed/XbvjZxUZJGg" frameBorder="0" allowFullScreen></iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      